import React, { Component, useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Collapse, Button, Row, Col } from 'reactstrap';
import { useAuth0 } from "@auth0/auth0-react";
import { FaStaylinked, FaLink, FaWarehouse, FaFileImport, FaRegBuilding, FaRegUserCircle, FaDoorOpen, FaChevronDown, FaChevronUp, FaHome, FaKey, FaBell, FaTree } from 'react-icons/fa';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGear, faUser, faCaretDown, faCaretUp, faRightFromBracket, faIndustry, faLink, faNewspaper } from '@fortawesome/free-solid-svg-icons'
import useAuth from "../Utilities/Hooks/useAuth";
import './Profile.css';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

library.add(faGear, faUser, faCaretDown, faCaretUp, faRightFromBracket, faIndustry, faLink, faNewspaper)

const Profile = () => {
    const { isAuthenticated, user, isLoading, logout } = useAuth0();
    const [defaultFarmId, setDefaultFarmId] = useLocalStorage('defaultFarmId', '');
    const [defaultFarmName, setDefaultFarmName] = useLocalStorage('defaultFarmName', '');
    const [defaultFarmUniqueId, setDefaultFarmUniqueId] = useLocalStorage('defaultFarmUniqueId', '');
    const [isAddArchiveItem, setIsAddArchiveItem] = useLocalStorage('isAddArchiveItem', '');
    const [isAddEditItem, setIsAddEditItem] = useLocalStorage('isAddEditItem', '');
    const [isCreateNewAction, setIsCreateNewAction] = useLocalStorage('isCreateNewAction', '');
    const [isSubmitEvidenceCloseAction, setIsSubmitEvidenceCloseAction] = useLocalStorage('isSubmitEvidenceCloseAction', '');
    const [isAddDeleteDocument, setIsAddDeleteDocument] = useLocalStorage('isAddDeleteDocument', '');
    const [saveRightsForNonItemFieldsAndTables, setSaveRightsForNonItemFieldsAndTables] = useLocalStorage('saveRightsForNonItemFieldsAndTables', '');
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);

    const [defaultFarmName1, setDefaultFarmName1] = useState(localStorage.getItem("defaultFarmName"));
    const [defaultFarmUniqueId1, setDefaultFarmUniqueId1] = useState(localStorage.getItem("defaultFarmUniqueId"));
    const { auth, setAuth } = useAuth();
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const navigate = useNavigate();
    const [caretDown, setCaretDown] = useState(true);
    const [menuOpen, setMenuOpen] = useState(false);
    const [userObj, setUserObj] = useState({});
    const [role, setRole] = useState({});    
    const [farmRoleName1, setFarmRoleName1] = useState({});   
    const [farmCount, setFarmCount] = useState(0);
    const [tcAccepted, setTCAccepted] = useState(false);

    useEffect(() => {

        setDefaultFarmName1(localStorage.getItem("defaultFarmName"))
        setDefaultFarmUniqueId1(localStorage.getItem("defaultFarmUniqueId"))
        setFarmRoleName1(localStorage.getItem("farmRoleName"));
        const currentUser = localStorage.getItem("auth");
        currentUser != null ? setUserObj(JSON.parse(currentUser)) : setUserObj({});

        if (auth != null) {
            var decodedToken = jwt_decode(auth.token);
            setRole(decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
        }
        OnPageload();

    }, [])

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/settings/GetMyInfoView/', {
                params: { Id: farmId, UserId: userId }
            }
            );
            if (response.data.status) {   
                setFarmCount(response.data.content.farmCount);
                setTCAccepted(response.data.content.tcAccepted);
            }

        } catch (err) {
            console.log(err);
        }
    }
    const myvineyardsummary = async (e) => {
        e.preventDefault();
        setDefaultFarmId(0);
        setDefaultFarmName(null);
        setDefaultFarmUniqueId(null);
        setIsAddArchiveItem(null);
        setIsAddEditItem(null);
        setIsCreateNewAction(null);
        setIsSubmitEvidenceCloseAction(null);
        setIsAddDeleteDocument(null);
        setSaveRightsForNonItemFieldsAndTables(null);
        setFarmRoleName(null);
        window.open('myvineyardsummary', "_self");
    }
    const logout1 = async () => {
        if (auth != null) {
            let form = {
                Email: auth.email
            }
            const response = await apiPost(
                '/api/Auth/Logout/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            setAuth({});
            localStorage.clear();
            //navigate('/auth0login');
            logout({ returnTo: window.location.origin })
        }
        else {
            localStorage.clear();
            //navigate('/auth0login');
            logout({ returnTo: window.location.origin })
        }
    }

    const handleClick = () => {
        setCaretDown(!caretDown);
        setMenuOpen(!menuOpen)
    }

    const handleBlur = () => {
        setMenuOpen(false);
        setCaretDown(true);
    }

    const openChangePassword = (id, routePath) => {
        navigate('/' + routePath, { state: { id: id } });
    }

    return (
        <div className="profile-div">
            <Row>
                <Col sm="6">
                     <div className="logo-farm-name">
                        <div className="header-logo">
                            <a href="javascript:void(0);"><img className="logo" src="/images/NZW_Logo.png" /></a>
                        </div>
                    </div>
                </Col>
               <Col sm="6">
                     <div className="profile-link" onBlur={handleBlur}>
                        <Button className="profile-button" style={{ width: "18vw" }} outline onClick={handleClick} >
                            <Row>
                                <Col sm="3">
                                    <img className="profileimage" src="/images/Sample-profile.jpg" />
                                </Col>
                                <Col sm="7">
                                    <div className="profile">
                                        <div class="profileUserName">{userObj.fullName} </div>
                                        {defaultFarmUniqueId1 != undefined && defaultFarmUniqueId1 != null &&
                                            <div className="profilefarmname">{(defaultFarmName1 == null || defaultFarmName1 == 'null') ? '' : defaultFarmName1}</div>
                                        }
                                    </div>
                                </Col>
                                <Col sm="2">
                                    <div className="profile caret caretoutline profilecart">
                                        {caretDown ? <FaChevronDown /> : <FaChevronUp />}
                                    </div>
                                </Col>
                            </Row>
                        </Button>
                        <Collapse isOpen={menuOpen}>
                            <div className="dropdown-menu-lg overflow-hidden p-0 dropdown-menu dropdown-menu-right show" id="settingsMenu">
                                <ul className="text-left bg-transparent list-group list-group-flush">
                                    <li className="list-group-item">
                                        <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                            <li className="nav-item">
                                                <Link to="/welcome" className="nav-link"><FaHome /> Welcome</Link>
                                            </li>
                                        </ul>
                                    </li>
                                    {
                                        role == 6 &&
                                        <li className="list-group-item">
                                            <span className="nav-link menu-setting-header">Settings </span>
                                            <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                                {localStorage.getItem("isSuperAdmin") == "true" && <>
                                                    <li className="nav-item">
                                                        <Link to="/externalorganisation" className="nav-link"><FaRegBuilding /> Organisations</Link>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="/user" className="nav-link profile-dropdown-item"><FaRegUserCircle /> Users</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="/farm" className="nav-link"><FaWarehouse /> Vineyards</a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a href="/uservineyard" className="nav-link"><FaLink /> User to Vineyard</a>
                                                    </li>
                                                </>}

                                                <li className="nav-item">
                                                    <a href="/accessmanager" className="nav-link"><FaStaylinked /> Access Manager</a>
                                                </li>
                                                {
                                                    localStorage.getItem("isSuperAdmin") == "true" &&
                                                    <li className="nav-item">
                                                        <a href="/import" className="nav-link"><FaFileImport /> Data Import</a>
                                                    </li>
                                                }
                                                <li className="nav-item">
                                                    <a className="nav-link" href="#" onClick={myvineyardsummary}><FaTree /> All Vineyards Summary</a>
                                                    {/*<button onClick={myvineyardsummary} className="nav-link"><FaTree /> My Vineyards</button>*/}
                                                </li>
                                            </ul>
                                        </li>
                                    }
                                    {
                                        role == 8 &&
                                        <> {(farmRoleName1 == "Manager" || (tcAccepted && farmCount > 1)) &&
                                            <li className="list-group-item">
                                                <span className="nav-link menu-setting-header">Settings </span>
                                                <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                                    {farmRoleName1 == "Manager" &&
                                                        <>

                                                            <li className="nav-item">
                                                                <a href="/accessmanager" className="nav-link"><FaStaylinked /> Access Manager</a>
                                                            </li>
                                                        </>
                                                    }
                                                    {
                                                        tcAccepted && farmCount > 1 &&
                                                        <li className="nav-item">
                                                            <a classNa me="nav-link" href="#" onClick={myvineyardsummary}><FaTree /> All Vineyards Summary</a>
                                                            {/*<button onClick={myvineyardsummary} className="nav-link"><FaTree /> My Vineyards</button>*/}
                                                        </li>
                                                    }
                                                </ul>
                                            </li>
                                        }
                                        </>
                                    }
                                    <li className="list-group-item">
                                        <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                            <li className="nav-item">
                                                <a href="/changepassword" onClick={(id, routePath) => openChangePassword(userId, 'changepassword')} className="nav-link"><FaKey /> Change Password</a>
                                            </li>
                                            <li className="nav-item">
                                                <button onClick={logout1} className="nav-link logout"><FaDoorOpen /> Logout</button>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </Collapse>
                    </div>
                </Col>
            </Row>
            
        </div>
    );
}

export default Profile